<template>
  <div>
    <b-row class="address-header-row">
      <b-col cols="12">
        <h3 class="page-title">View Address</h3>
      </b-col>
      <!-- <b-col>
        <b-button
          class="add-address-btn-right"
          variant="outline-primary"
          @click="$router.push({ name: 'address-create' })"
          >Add New Address</b-button
        >
      </b-col> -->
    </b-row>

    <b-row class="address-cards-row">
      <b-col cols="12" sm="12" md="6" lg="4" v-for="(item, i) in address" :key="i" class="mb-3">
        <div class="addressNo">
          <b-row class="address-name-row">
            <b-col cols="12" sm="8">
              <h4 class="customer-name-text">
                <span class="text-info"> Customer Name : </span>
                <span>{{ item.fullName }}</span>
              </h4>
            </b-col>
            <b-col cols="12" sm="4" class="text-right text-sm-right">
              <b-button
                v-if="item.isDefault"
                variant="outline-primary"
                class="default-btn"
                >Default</b-button
              >
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12">
              <h5 class="address-text">
                <span class="text-info">Delivery Address : </span>
                <span class="text-black">
                  {{ item.street1 }},{{ item.street2 }}, <br />
                  {{ item.city }}, {{ item.state }},<br />
                  {{ item.country }},
                  {{ item.zip }}
                </span>
              </h5>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-for="(phone, k) in item.contacts" :key="k">
            <b-col cols="12">
              <h5
                v-if="phone.contactType === 'PRIMARY_PHONE'"
                class="phone-text"
              >
                <span class="text-info">Customer Phone : </span>
                <span>{{ phone.value }}</span>
              </h5>
            </b-col>
            <!-- <b-col>
              <b-button
                variant="primary"
                style="float: right; border-radius: 16px"
                >Edit</b-button
              ></b-col
            > -->
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import addressCreateVue from "./addressCreate.vue";
// import { mapGetters } from "vuex";
export default {
  // components: { addressCreateVue },
  data() {
    return {
      currentUser: "",
      address: "",
    };
  },

  computed: {
    // ...mapGetters({
    //   addAddress: "customerManagement/GetAddressList",
    // }),
  },

  methods: {
    // createAddress() {
    //   this.$router.push({
    //     path: "/createAddress",
    //     name: "address-create",
    //   });
    // },
    async fetchAddressData() {
      const payload = {
        id: this.currentUser.id,
      };
      const data = await this.$store.dispatch(
        "customerManagement/customerDetails",
        payload
      );
      return (this.address = data ? data.addresses : "");
    },
  },
  async mounted() {
    this.currentUser = this.$route.params;
    await this.fetchAddressData();
  },
};
</script>

<style scoped>
.btn-secondary {
  border-radius: 50%;
  background-color: #42b039;
  border-color: #42b039;
  height: 44px;
  color: #fff;
}

.btn-secondary.btn-secondary:hover {
  color: #fff;
  background-color: #62c45a;
  border-color: #62c45a;
}

.addressNo {
  border: 1px solid #efefef;
  box-shadow: 0px 0px 6px 0px #ddd;
  border-radius: 10px;
  padding: 14px;
  width: 100%;
 
  min-height: 170px;
  height: auto;
}

.page-title {
  margin-bottom: 0;
}

.address-header-row {
  align-items: center;
  margin-bottom: 1rem;
}

.add-address-btn-right {
  float: right;
}

.address-cards-row {
  align-items: stretch;
}

.address-name-row {
  align-items: center;
}

.customer-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
}

.default-btn {
  float: right;
  border-radius: 16px;
}

.address-text {
  text-overflow: ellipsis;
  word-break: break-word;
  margin-bottom: 0;
  line-height: 1.35;
}

.phone-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  line-height: 1.35;
}

@media (max-width: 767.98px) {
  .addressNo {
    max-width: 100%;
    min-height: auto;
  }

  .default-btn {
    float: none;
    width: 100%;
    margin-top: 0.5rem;
  }

  .customer-name-text,
  .phone-text {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }
}
</style>
